// extracted by mini-css-extract-plugin
export var alertIcon = "_qz-0";